import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'

import { Enums } from '@cyborg-monorepo/hunter/common'
import { SupportedTools } from '@cyborg-monorepo/hunter/matchboi'

import { VerityEnvironmentService } from '../../../../../environments/verity-environment.service'
import { AstNode } from '../../hunt-package-details/components/tuning/utils/types'

@Injectable({ providedIn: 'root' })
export class TuningAPIService {
  private readonly http = inject(HttpClient)
  private readonly verityEnvironmentService = inject(VerityEnvironmentService)

  /** Fetch primary & secondary pivot fields for a hunt category */
  getFieldsForTool(tool: SupportedTools, huntCategory: Enums.HuntCategoryEnum) {
    const params = new HttpParams()
      .set('tool', tool)
      .set('huntCategory', huntCategory)
    return this.http.get<string[]>(
      `${this.verityEnvironmentService.apiUrl}/tuning/tool-fields`,
      {
        params,
      },
    )
  }

  /** Generate tuning content from the server */
  generateTuningContentFromFilter(
    filter: AstNode,
    toolId: string,
    category?: string,
  ) {
    let params = new HttpParams().set('toolId', toolId)
    if (category) params = params.set('category', category)

    return this.http.post(
      `${this.verityEnvironmentService.apiUrl}/tuning/render`,
      { filter },
      {
        params,
        responseType: 'text' as const,
      },
    )
  }
}
